import { createContext, useContext, useState, ReactNode } from 'react';
import { CareerPath } from '@/types/career';

interface CareerPathContextType {
  careerPath: string | null;
  setCareerPath: (path: string) => void;
  pathDetails: CareerPath | null;
  setPathDetails: (details: CareerPath) => void;
}

const CareerPathContext = createContext<CareerPathContextType | undefined>(undefined);

export function CareerPathProvider({ children }: { children: ReactNode }) {
  const [careerPath, setCareerPath] = useState<string | null>(null);
  const [pathDetails, setPathDetails] = useState<CareerPath | null>(null);

  return (
    <CareerPathContext.Provider value={{
      careerPath,
      setCareerPath,
      pathDetails,
      setPathDetails
    }}>
      {children}
    </CareerPathContext.Provider>
  );
}

export function useCareerPathDetails() {
  const context = useContext(CareerPathContext);
  if (context === undefined) {
    throw new Error('useCareerPathDetails must be used within a CareerPathProvider');
  }
  return context;
}